var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    stroke: "#D8E1EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3256 16.1367H31.6729V31.8599H40.3256V16.1367Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2223 24.0002C32.2207 22.4858 32.5599 20.9908 33.2143 19.6285C33.8687 18.2662 34.8211 17.0723 35.9993 16.1373C34.5405 14.978 32.7885 14.2571 30.9436 14.057C29.0987 13.8569 27.2354 14.1857 25.5666 15.0057C23.8977 15.8257 22.4907 17.1039 21.5064 18.6942C20.522 20.2845 20 22.1228 20 23.9988C20 25.8749 20.522 27.7132 21.5064 29.3035C22.4907 30.8938 23.8977 32.172 25.5666 32.992C27.2354 33.812 29.0987 34.1407 30.9436 33.9406C32.7885 33.7405 34.5405 33.0197 35.9993 31.8604C34.8214 30.9257 33.8693 29.7322 33.2149 28.3705C32.5606 27.0087 32.2211 25.5142 32.2223 24.0002Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0003 24.0014C52.0002 25.8776 51.4781 27.716 50.4936 29.3063C49.509 30.8967 48.1018 32.1749 46.4328 32.9948C44.7637 33.8147 42.9002 34.1432 41.0552 33.9428C39.2103 33.7424 37.4583 33.0212 35.9995 31.8616C37.1769 30.926 38.1288 29.7322 38.7833 28.3704C39.4379 27.0085 39.778 25.5141 39.778 24C39.778 22.4859 39.4379 20.9915 38.7833 19.6296C38.1288 18.2678 37.1769 17.074 35.9995 16.1384C37.4583 14.9788 39.2103 14.2576 41.0552 14.0572C42.9002 13.8568 44.7637 14.1853 46.4328 15.0052C48.1018 15.8251 49.509 17.1033 50.4936 18.6937C51.4781 20.284 52.0002 22.1224 52.0003 23.9986V24.0014Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.2e69b7abba093e34206f9e1c4224162b.svg";
export { ForwardRef as ReactComponent };